import { css } from '@emotion/css';
import { makeStyles, theme } from '@branchjs/neo-components';

export const ScreenRoiAnalyticsStyles = {
  screenContainer: css({
    flex: 1,
    padding: `0 ${theme.spacing(3)} 1px ${theme.spacing(3)}`,
    background: theme.colors.gray[0],
  }),
};

export const useStyles = makeStyles({
  menu: {
    '& .MuiTypography-h2': {
      fontSize: 16,
      fontWeight: 600,
    },
  },
});
